import { breakpoints } from '../../domain/services/breakpointService/breakpointConfig.js';

const cache = new Map();

export const getBreakpoint = width => {
  if (!cache.has(width)) {
    const breakpoint =
      breakpoints.find(bp => width < bp.width)?.name || 'large_desktop';
    cache.set(width, breakpoint);
  }
  return cache.get(width);
};
